<template>
  <el-dialog
    title="合作项目介绍"
    :visible="true"
    width="1000px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="
      () => {
        handleClose(false)
      }
    "
    append-to-body
  >
    <div class="box">
      <div class="view-title">合作项目介绍</div>
      <div v-html="content"></div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'ApplicationPreview',
  props: ['handleClose', 'defaultContent'],
  data() {
    return {
      content: this.defaultContent
    }
  }
}
</script>
<style lang="scss" scoped>
.box {
  padding: 20px;
  min-height: 500px;
  .view-title {
    margin: 0 auto 50px;
    width: 233px;
    height: 50px;
    line-height: 50px;
    font-size: 36px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #0853b6;
    line-height: 8px;
  }
}
</style>